/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_RejectingInputs */

const en_samples_rejecting = /** @type {(inputs: Samples_RejectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejecting...`)
};

const es_samples_rejecting = /** @type {(inputs: Samples_RejectingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazando...`)
};

/**
* | output |
* | --- |
* | "Rejecting..." |
*
* @param {Samples_RejectingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_rejecting = /** @type {((inputs?: Samples_RejectingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_RejectingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_rejecting(inputs)
	return es_samples_rejecting(inputs)
});